import { fetchBusiness } from '/api/admin';

export const useBusinessServices = async () => {
  const { data, error } = await useAsyncData(
    'business',
    () =>
      fetchBusiness()
        .then((businessList) => {
          return businessList;
        })
        .then((businessList) =>
          businessList.map((business) => ({
            ...business,
            isSelected: false,
          })),
        )
        .then((businessList) => [{ name: '전체', id: '', isSelected: true }, ...businessList]),
    {
      // server: false, => ssr 에서 에레발생한다.
      default: () => [],
    },
  );

  return {
    business: data,
    error,
    // pending,
  };
};
